<template>

  <background-video />
  <div class="z-10 flex m-auto flex-col items-center justify-center gap-8 w-full min-w-0 px-4">
    <div class="w-full max-w-[300px] sm:max-w-[355px] mb-12 sm:mb-[145.5px]">
      <img width="453" class="w-full h-auto" src="../assets/logo.svg" alt="Sorenson Forum" />
    </div>
    <div class="w-full flex flex-col items-center justify-center gap-4">
      <a
        id="homepage_host_session"
        class="w-full max-w-80 text-[#6CBFFF] px-6 py-3 bg-[#293f52] hover:bg-opacity-30 rounded-[16px] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
        @click="handleHostClick"
      >
        <lib-icon name="media/microphone/outline" size="24" />
        <div class="justify-start text-xl sm:text-[24px] font-medium font-['Inter'] leading-normal">
        {{ $t('home_host') }}
        </div>
      </a>
      <router-link to="/join" id="homepage_join_session" class="w-full max-w-80 px-6 py-3 bg-[#6CBFFF] hover:bg-opacity-30 rounded-[16px] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer">
        <lib-icon name="media/headphones/outline" size="24" />
        <div class="justify-start text-black text-xl sm:text-[24px] font-medium font-['Inter'] leading-normal">
              {{ $t('home_join')}}
          </div>
      </router-link>
    </div>

    <div class="flex flex-col items-center justify-center gap-6 mt-10 sm:mt-16 sm:px-[4%]">
      <p class="text-white text-[17px] sm:text-[19px] text-center flex flex-col sm:flex-row items-center justify-center sm:h-8 sm:whitespace-nowrap">
        <span>Professional captions and translation for<span class="hidden sm:inline">&nbsp;</span></span>
        <span class="relative inline-block h-8 w-[140px] overflow-hidden align-middle top-[1px]">
          <transition-group
            name="slide-up"
            tag="span"
          >
            <span
              v-for="(word) in [currentWord]"
              :key="word"
              class="absolute left-0 w-full text-white text-[17px] sm:text-[19px] text-center sm:text-left"
            >
              {{ word }}
            </span>
          </transition-group>
        </span>
      </p>
      <a v-if="!authorized" @click="handleTryFreeClick" class="text-xl text-primary cursor-pointer">{{ $t('home_footer_cite_sub') }}</a>
    </div>
  </div>

  <main-footer></main-footer>


</template>

<script>
// @ is an alias to /src
import MainFooter from '@/components/MainFooter.vue';
import BackgroundVideo from "@/components/ui/BackgroundVideo.vue";
import {mapMutations, mapState} from "vuex";
import emitter from "@/services/emitter.service";
import LibIcon from "@/components/ui/LibIcon.vue";
import { getPendo } from '@/services/pendo.service';

export default {
  name: 'HomeView',
  components: {
    LibIcon,
    MainFooter,
    BackgroundVideo
  },
  data() {
    return {
      animatedWords: ['events', 'education', 'church', 'enterprise', 'manufacturing'],
      currentWordIndex: 0,
      intervalId: null,
    };
  },
  methods: {
    ...mapMutations('nonpersist', ['setShowGuide']),
    handleHostClick() {
      if (!this.authorized) {
        emitter.emit('open-auth0');
      } 
      else {
        emitter.emit('open-host-modal');
      }
    },
    handleTryFreeClick(){
      emitter.emit('open-auth0');
    }
  },
  computed: {
    ...mapState('auth', ['authorized']),
    ...mapState('nonpersist', ['showGuide', 'user']),
    currentWord() {
      return this.animatedWords[this.currentWordIndex];
    }
  },
  mounted() {
    if (this.showGuide) {
      console.log("guide");
      setTimeout(() => {
            const pendo = getPendo(this.user);
            if (pendo) {
              pendo.showGuideById('A8qrMfEEgZ2Fy2GOGaNgpZPoBN8');
            }
            this.setShowGuide(false);
          }, 1000
      );
    }
    // Start animated word interval
    this.intervalId = setInterval(() => {
      this.currentWordIndex = (this.currentWordIndex + 1) % this.animatedWords.length;
    }, 1800);

  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  }
}
</script>

<style lang="scss" scoped>

.center-logo {
  width: 670px;

  @media all and (max-height: 800px) {
    max-width: 550px;
  }
}

.home__actions {
  display: flex;
  flex-direction: column;
  align-items: center;

  a:hover {
    opacity: 0.9;
  }

  @media all and (max-height: 800px) {
    .orange-btn {
      height: 70px;

      img {
        width: 45px;
      }
    }
  }


}

.home__actions-or {
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.875rem;
  text-transform: uppercase;

  color: #C2C2C2;
  margin: 21px auto 10px;
}

.home__slogan {
  color: #fff;
  font-size: 1.8rem;
  text-align: center;
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: all 0.5s;
}
.slide-up-enter-from {
  opacity: 0;
  transform: translateY(1.5rem); /* 6 * 0.25rem = 1.5rem */
}
.slide-up-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.slide-up-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-1.5rem);
}
</style>